import { render, staticRenderFns } from "./BusinessTypeTable.vue?vue&type=template&id=172e141f&scoped=true&"
import script from "./BusinessTypeTable.vue?vue&type=script&lang=ts&"
export * from "./BusinessTypeTable.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessTypeTable.vue?vue&type=style&index=0&id=172e141f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172e141f",
  null
  
)

export default component.exports